import './index.scss';
export default function SvgIcon(props) {
    const omit = (obj, uselessKeys) =>
        Object.keys(obj).reduce((acc, key) => {
            return uselessKeys.includes(key)
                ? acc
                : { ...acc, [key]: obj[key] };
        }, {});
    let nativeProps = omit(props, ['iconName']);
    return (
        <svg
            {...nativeProps}
            aria-hidden="true"
            className={'svg-icon ' + props.iconName + ' ' + props.className}>
            <use xlinkHref={'#' + props.iconName}></use>
        </svg>
    );
}
